module.exports = __webpack_public_path__ + "static/media/phone-monitor-progress-mobile.67906733.png";